module.exports = __webpack_public_path__ + "img/voluntariado.d81ee733.jpg";